import React from 'react';

import Icon from '@wetransfer/transfer/component/icon';
import Browser from '@wetransfer/transfer/modules/concorde-browser';

import { BUY_BUTTON_LABEL } from './constants';
import { FooterButtonProps } from './types';

export const FooterButton: React.FC<FooterButtonProps> = React.memo(
  function FooterButton({ tabIndex, className, onClick, isDisabled = false }) {
    return (
      <button
        style={Browser.isMobile ? { width: '100%' } : undefined}
        key="transfer_footer_action"
        tabIndex={tabIndex}
        className={className}
        onClick={onClick}
        disabled={isDisabled}
      >
        {Browser.isMobile && <Icon type="Purchase" />}
        {BUY_BUTTON_LABEL}
      </button>
    );
  }
);
